//TODO-KSEB: refactor when loading from server

import { PigGenderTypes } from "./pig-gender-types";
import { PigGender } from "./pig-gender.type";

export class PigGenderType implements PigGender {
  id: number;
  name: string;

  constructor(id: number, name: string) {
    this.id = id;
    this.name = name;
  }

  static fromId(id: number): PigGender {
    switch (id) {
      case PigGenderTypes.Sow.id:
        return new PigGenderType(PigGenderTypes.Sow.id, PigGenderTypes.Sow.name);
      case PigGenderTypes.Castrate.id:
        return new PigGenderType(PigGenderTypes.Castrate.id, PigGenderTypes.Castrate.name);
      case PigGenderTypes.MixedControlled.id:
        return new PigGenderType(PigGenderTypes.MixedControlled.id, PigGenderTypes.MixedControlled.name);
      case PigGenderTypes.MixedUnknown.id:
        return new PigGenderType(PigGenderTypes.MixedUnknown.id, PigGenderTypes.MixedUnknown.name);
      case PigGenderTypes.MalePig.id:
        return new PigGenderType(PigGenderTypes.MalePig.id, PigGenderTypes.MalePig.name);
      default:
        throw new Error('Invalid PigGender id: ' + id);
    }
  }

  static fromString(name: string): PigGender {
    switch (name) {
      case PigGenderTypes.Sow.name:
        return new PigGenderType(PigGenderTypes.Sow.id, PigGenderTypes.Sow.name);
      case PigGenderTypes.Castrate.name:
        return new PigGenderType(PigGenderTypes.Castrate.id, PigGenderTypes.Castrate.name);
      case PigGenderTypes.MixedControlled.name:
        return new PigGenderType(PigGenderTypes.MixedControlled.id, PigGenderTypes.MixedControlled.name);
      case PigGenderTypes.MixedUnknown.name:
        return new PigGenderType(PigGenderTypes.MixedUnknown.id, PigGenderTypes.MixedUnknown.name);
      case PigGenderTypes.MalePig.name:
        return new PigGenderType(PigGenderTypes.MalePig.id, PigGenderTypes.MalePig.name);
      default:
        throw new Error('Invalid PigGender name: ' + name);
    }
  }
}
